import { LineItemType } from '../../type/order';
import { PriceCalculationParams } from './PriceCalculationParams';
/**
 * Params to use when calculating the price of a real-time line item
 */
export class RealTimePriceCalculationParams extends PriceCalculationParams {
    // timeRanges are not required when requesting the price of 1 minute
    constructor(timeRanges = []) {
        super(timeRanges);
        this.type = LineItemType.RealTime;
    }
}
